import { Controller } from "@hotwired/stimulus"

const LOAD_MARGIN = "1600px"

// Connects to data-controller="video-block-load"
export default class extends Controller {
  static targets = ["block"]

  connect() {
    this.#setObserver()
  }

  blockTargetConnected(target) {
    this.observer?.observe(target)
  }

  blockTargetDisconnected(target) {
    this.observer?.unobserve(target)
  }

  reload() {
    this.visibleElements.forEach((elem) => {
      this.#reload(elem)
    })
  }

  reloadByTime(startTime, endTime) {
    this.visibleElements.forEach((elem) => {
      const elemStartTime = parseFloat(elem.dataset.timeCodeStart)
      const elemEndTime = parseFloat(elem.dataset.timeCodeEnd)
      if (startTime <= elemEndTime && elemStartTime <= endTime) {
        this.#reload(elem)
      }
    })
  }

  #setObserver() {
    if (this.observer) {
      this.observer.disconnect()
    }
    this.visibleElements = new Set()

    this.observer = new IntersectionObserver(this.#handleIntersection.bind(this), {
      root: null,
      rootMargin: LOAD_MARGIN,
      threshold: 0,
    })

    this.blockTargets.forEach((block) => {
      this.observer.observe(block)
    })
  }

  #handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (!this.visibleElements.has(entry.target)) {
          this.#load(entry.target)
          this.visibleElements.add(entry.target)
          return
        }
      } else {
        if (this.visibleElements.has(entry.target)) {
          this.#hide(entry.target)
          this.visibleElements.delete(entry.target)
          return
        }
      }
    })
  }

  #reload(target) {
    target.removeAttribute("src")
    target.removeAttribute("complete")
    requestAnimationFrame(() => {
      target.src = target.dataset.src
    })
  }

  #load(target) {
    if (!target.src) {
      target.src = target.dataset.src
    }
  }

  #hide(target) {
    target.removeAttribute("src")
    target.removeAttribute("complete")
    const dummy = document.createElement("div")
    dummy.style.height = target.clientHeight + "px"
    target.children[0].replaceWith(dummy)
  }
}
